import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import { PsHttpService } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

import type { AbCheckApi } from '../ab-check-api';
import type { AbCheckResponse } from '../../types';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';

@injectable()
export class AbCheckApiImpl extends PsHttpService implements AbCheckApi {
    get options() {
        return {
            baseURL: '/api',
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }

    async checkAbTest(functionName: string): Promise<boolean> {
        const result = await this.post<PatSnapSuccessResponseData<AbCheckResponse>>({
            url: `ab/check/${functionName}`,
            baseURL: coreTelecomApiUrlPrefix,
        });
        return result.data;
    }
}
